<div class="tenant-integrations-card rounded-3 bg-white border shadow-sm">
  <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
    <div class="text-uppercase tenant-integrations-heading">Connected services</div>
    <button type="button" class="btn btn-light btn-sm rounded-small border px-3">
      + Add integration
    </button>
  </div>

  <div class="tenant-integrations-grid mb-5">
    <article
      v-for="service in connected_services"
      :key="service.key"
      class="tenant-integration-item"
      :class="{ 'is-connected': service.connected }"
    >
      <div class="tenant-integration-title">{{ service.name }}</div>
      <div class="tenant-integration-copy">{{ service.copy }}</div>
      <div class="tenant-integration-status" :class="service.connected ? 'is-live' : 'is-offline'">
        {{ service.connected ? 'Connected · Live' : 'Not connected' }}
      </div>
    </article>
  </div>

  <div class="tenant-integration-section-divider mb-4"></div>

  <div class="mb-4">
    <div>
      <div class="text-uppercase tenant-integrations-heading mb-2">Verification services</div>
      <div class="tenant-integration-copy mt-0">
        Select the services that activate verification. Service mappings remain configured in Config.
      </div>
    </div>
  </div>

  <div v-if="integrations_error" class="case-details-doc-message is-error rounded-3 px-3 py-2 mb-3">
    {{ integrations_error }}
  </div>

  <div v-if="loading" class="tenant-integration-empty border rounded-3">
    Loading verification services...
  </div>
  <div v-else-if="!services.length" class="tenant-integration-empty border rounded-3">
    No verification services are available.
  </div>
  <div v-else class="tenant-integrations-grid">
    <article
      v-for="service in services"
      :key="service.id"
      class="tenant-integration-item"
      :class="{ 'is-connected': service_is_selected(service) }"
    >
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <div class="tenant-integration-title">{{ service.name }}</div>
          <div class="tenant-integration-copy">{{ service.description }}</div>
        </div>
        <div class="form-check form-switch flex-shrink-0">
          <input
            class="form-check-input tenant-integration-toggle"
            type="checkbox"
            role="switch"
            :aria-label="`${service_is_selected(service) ? 'Disable' : 'Enable'} ${service.name}`"
            :checked="service_is_selected(service)"
            :disabled="loading"
            @change="toggle_service(service)"
          >
        </div>
      </div>
      <div class="tenant-integration-status" :class="service_is_selected(service) ? 'is-live' : 'is-offline'">
        {{ service_is_selected(service) ? 'Enabled' : 'Not enabled' }}
      </div>
    </article>
  </div>
</div>
